module.exports = __webpack_public_path__ + "static/media/molly.45fdd648.png";